module.exports = __webpack_public_path__ + "static/media/anchorage_marker_dark_blue.98ec1db2.svg";